import axios from 'axios';

import auth from "@/store/authentication.js";

const user_role = auth.state.user_role;

export default {
  findAll(ctx) {
    return axios.get(api_url + user_role + "/partners", {
      params: {ctx: ctx}
    });
  },
  steps() {
    return axios.get(api_url + user_role + "/partners/steps");
  },
  find(id) {
    return axios.get(api_url + user_role + "/partners/" + id);
  },
  create(params) {
    return axios.post(api_url + user_role + "/partners", params);
  },
  update(params) {
    return axios.post(api_url + user_role + "/partners/" + params.id, params.partner);
  },
  checkEsbozo(params) {
    return axios.post(api_url + user_role + "/partners/" + params.id + "/check-esbozo", params.partner);
  },
  createExpos(params) {
    return axios.post(api_url + user_role + "/partners/" + params.id + "/create-expos", params.partner);
  },
  updateExpos(params) {
    console.log("update-expos2");
    return axios.post(api_url + user_role + "/partners/" + params.id + "/update-expos", params.partner);
  },
  checkExpos(params) {
    return axios.post(api_url + user_role + "/partners/" + params.id + "/check-expos", params.partner);
  },
  delete(id) {
    return axios.delete(api_url + user_role + "/partners/" + id);
  },
  contractsRegistration(params) {
    return axios.post(api_url + user_role + "/partners/" + params.id + "/contracts-registration", params.partner);
  },
  generateDownload(id) {
    return axios.get(`${api_url}${user_role}/generate-download/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/partner.js